<template>
  <footer class="site-footer">
    <a href="https://mon-devis.deck-linea.com/devis/garde-corps?utm_source=www.oxynov.fr" target="_blank" class="faq-pg-section section-padding-50" style="background-color: #025d90;padding: 50px 0;display: block" title="Faire son devis gratuitement de garde-corps inox">
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            <h4>Votre devis de garde-corps - Cliquez ici pour en savoir plus <i class="fa fa-mouse-pointer" aria-hidden="true"></i></h4>
          </div>
        </div>
      </div>
    </a>
    <div class="upper-footer">
      <div class="container">
        <div class="row">
          <div class="col col-md-3 col-sm-6">
            <div class="widget about-widget">
              <div class="footer-logo"><img src="../assets/images/oxynov-logo_blanc.svg" alt="Le spécialiste du garde-corps inox" width="211" height="50"></div>
              <p class="f-t-11">
                Fabricant d’accessoires et de pièces pour garde-corps inox depuis 2010. OXYNOV propose en partenariat avec Decklinea, une gamme de modèles facile à installer.
                Le logiciel de devis 3D en ligne permet de réaliser son chiffrage et son plan très simplement.
                Une gamme exclusive réservée aux professionnels de 5000 articles en stock est disponible en moins de 72h sur notre site PRO : <a href="https://pro.oxynov.fr" target="_blank" title="Oxynov pro, pour les professionnels de l'inox">pro.oxynov.fr</a>
                Toutes nos solutions sont faciles à monter soi-même ! Vous pourrez ainsi profiter de votre garde-corps inox en intérieur ou à l’extérieur (terrasse, balcon, sous une <a href="https://www.direct-abris.com/pergolas-c6.html" target="_blank" title="Pergola sur mesure chez Direct Abris">pergola</a>…)
              </p>
            </div>
          </div>
          <div class="col col-md-3 col-sm-6">
            <div class="widget about-widget">
              <h3>NOS BUREAUX</h3>
              <ul class="contact-info">
                <li><i class="fa fa-home"></i>2 rue de la Carnoy<br> 59130 Lambersart</li>
                <li><i class="fa fa-phone"></i>03 20 07 05 04</li>
                <li><i class="fa fa-home"></i> Horaire d'ouverture: <br>Lun-Ven (9h00 - 17h00)</li>
              </ul>
            </div>
          </div>
          <div class="col col-md-3 col-sm-6">
            <div class="widget quick-links-widget">
              <h3>DEVIS GRATUIT 3D</h3>
              <p>Réalisez rapidement et gratuitement un devis de garde-corps inox 100% Gratuit</p>
            </div>
          </div>
          <div class="col col-md-3 col-sm-6">
            <div class="widget twitter-feed-widget">
              <h3>NOS REVENDEURS</h3>
              <ul>
                <li><strong><a href="https://www.deck-linea.com/92-garde-corps-inox" target="_blank" title="La boutique du garde-corps inox, Decklinea">Deck-Linea.com</a></strong><br>Vente aux particuliers de la solution Oxynov</li>
                <li><strong><a href="https://pro.oxynov.fr" target="_blank" title="Pour les professionnels de l'inox">Oxynov PRO</a></strong><br>Le spécialiste du garde-corps pour les professionnels</li>
              </ul>
           </div>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright-info">
      <div class="container">
        <p>Oxynov® est une marque déposée de la société FORESTIA® - <router-link to="/mentions-legales" title="Mentions légales">Mentions Légales</router-link> - 2018</p>
        <p>Nos sites partenaires : <a href="https://www.deck-linea.com/" target="_blank" title="Deck linea">Deck-linéa</a>, <a href="http://www.terrassebois.com/" target="_blank" title="Terrasse bois">Terrasse bois</a>, <a href="https://www.fiberdeck.fr/" target="_blank" title="Fiberdeck, pour les professionnels de la terrasse composite">Fiberdeck</a>, <a href="https://pro.oxynov.fr/" target="_blank" title="pour les Professionnels de l'inox">Oxynov PRO</a>, <a href="http://www.cobrafastener.fr/" target="_blank" title="Cobrafastener">Cobrafastener</a></p>
      </div>
    </div>
  </footer>
</template>

<script>
import { EventBus } from '@/event-bus.js'

export default {
  name: 'Footer',
  methods: {
    openModal (name) {
      EventBus.$emit('open-modal', 'modal-3d')
    }
  }
}
</script>

<style scoped>
footer h4 {
  margin: 0;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: -0.5px;
}
footer h4 i {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue